<template>
  <a-form ref='ruleForm' :rules="rules" :model='form' :labelCol="{span:3}" :wrapper-col="{span:19}">

    <a-form-item label="指定门店" required>
      <div class="m-b-10">
        <a-button type="primary" @click="storeVisible=true" class="m-r-10">添加门店</a-button>
      </div>
      <div>
        <a-table :pagination='false' bordered :columns='columns' :data-source='storeList' :scroll="{ x: 'max-content'}">
          <template v-slot:name="{ record }">
            {{record.store_name?record.store_name:'-'}}
          </template>
          <template v-slot:range="{ record }">
            <a-input-number :precision="0" v-model:value="record.range" style="width:300px; text-align: center" placeholder="范围" />
          </template>
          <template v-slot:action="{ index }">
            <a-button type="danger" size="small" href="javascript:;" @click="del(index)">删除</a-button>
          </template>
        </a-table>
      </div>
    </a-form-item>
    <a-form-item :wrapper-col="{offset:10}">
      <a-button @click="submit" type="primary" class="m-r-10">确定</a-button>
      <a-button @click="cancel">取消</a-button>
    </a-form-item>
  </a-form>
  <!-- 选择门店 -->
  <a-modal  :keyboard="false" v-model:visible="storeVisible" centered :width='1200' :footer="null" destroyOnClose>
    <selectStore v-on:select="storeSelect" :selectList='storeList' :checkout='true' :canCancel="false" :hiddenHead='true'></selectStore>
  </a-modal>
</template>

<script>
import { inject, onMounted, reactive, ref, toRefs } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { getArea } from "@/api/public";
import { message } from "ant-design-vue";
const columns = [
  {
    title: "名称",
    dataIndex: "name",
    key: "name",
    slots: { customRender: "name" },
  },

  {
    title: "经纬度",
    dataIndex: "latlng",
    key: "latlng",
    customRender: ({ record }) => {
      return record.lat + "-" + record.lng;
    },
  },
  {
    title: "范围 (米)",
    dataIndex: "range",
    key: "range",
    slots: { customRender: "range" },
  },
  {
    title: "操作",
    key: "action",
    slots: { customRender: "action" },
  },
];
export default {
  components: {},
  name: "storeComponents",
  setup(props, { emit }) {
    const ruleForm = ref();
    const form = ref({ store_arr: [], rule_mark_store: 1 });
    // 门店选择
    const storeState = reactive({
      storeVisible: false,
      storeList: [],
    });
    const storeSelect = (data) => {
      console.log(data);
      var storeList = storeState.storeList;
      var list = [];
      data.forEach((element) => {
        var flag = false;
        storeList.forEach((v) => {
          if ((element.id || element.store_id) == (v.id || v.store_id)) {
            flag = v.range;
          }
        });
        if (flag) {
          element.range = flag;
        }
        list.push(element);
      });
      storeState.storeList = list;
      //   // 数组去重
      //   var obj={}
      //   storeState.storeList=storeState.storeList.reduce((cur,next) => {
      //     obj[next.id]||obj[next.store_id] ? "" : obj[next.store_id] = true && cur.push(next);
      //     return cur;
      // },[])
      console.log(storeState.storeList);

      storeState.storeVisible = false;
    };
    // 删除
    const del = (index) => {
      storeState.storeList.splice(index, 1);
    };
    onMounted(() => {});
    const submit = () => {
      if (!storeState.storeList.length) {
        message.error("请选择门店！");
        return false;
      }
      ruleForm.value.validate().then(async (res) => {
        emit("ployDone", { ...form.value, store_arr: storeState.storeList });
      });
    };
    const cancel = () => {
      emit("cancel");
    };
    const renderDetail = (data, index) => {
      console.log(data);
      form.value = data;
      form.value.index = index;
      storeState.storeList = data.store_arr || [];
    };
    return {
      ruleForm,
      form,
      columns,
      ...toRefs(storeState),
      storeSelect,
      del,
      confirm,
      submit,
      cancel,
      renderDetail,
    };
  },
};
</script>